<div class="popinDeliveryServiceContainer vc-modal__innerContainer">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <ng-container [ngSwitch]="data.type">
    <article class="popinDeliveryService vc-body2 vcModal__container" *ngSwitchCase="'directShippingBuyer'">
      <h3
        class="popinDeliveryService__title vc-modal__title vc-title-s"
        i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.TITLE"
      >
        Direct Shipping
      </h3>
      <p class="popinDeliveryService__heading" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.HEADING">
        Direct Shipping is available for a select number of items, and only from our Trusted and Expert Sellers. It has
        4 benefits:
      </p>
      <ul class="popinDeliveryService__list">
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.ITEM_1">
          <b>It’s affordable:</b> Save {{ dsPromo }} on average by opting out of physical control and authentication and
          consequently waiving your shipping fees.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.ITEM_2">
          <b>It’s trustworthy:</b> Only our Trusted and Expert Sellers are eligible, members who sell regularly, ensure
          their items conform to their descriptions and ship quickly.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.ITEM_3">
          <b>It’s quick:</b> Reduce your delivery time by up to 40% as your item skips the visit to our control and
          authentication center.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.ITEM_4">
          <b>It’s eco-friendly:</b> Lower your shipping emissions as your parcel takes the most direct path to your
          home.
        </li>
      </ul>
      <p class="popinDeliveryService__paragraph" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LAST_PARAGRAPH">
        Look out for
        <img
          class="popinDeliveryService__paragraph__icon"
          src="/assets/images/icons/handshake.svg"
          width="24"
          height="24"
          alt="Direct Shipping Icon"
        />
        Direct Shipping’ in our listings to see if your coveted item is eligible! For more information about Direct
        Shipping as a buyer or a seller, visit our
        <a
          i18n-href="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LAST_PARAGRAPH.LINK_URL"
          href="https://faq.vestiairecollective.com/hc/en-gb/categories/201084365-Buyer"
          target="_blank"
          rel="noopener noreferrer"
          >FAQ</a
        >.
      </p>
    </article>

    <article class="popinDeliveryService vc-body2 vcModal__container" *ngSwitchCase="'directShippingTopTier'">
      <h3
        class="popinDeliveryService__title vc-modal__title vc-title-s"
        i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.TITLE"
      >
        Direct Shipping
      </h3>

      <p class="popinDeliveryService__heading" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.HEADING.TOPTIER">
        This seller has been selected to offer Direct Shipping on items above {{ topTierLimit }} based on their track
        record in quality and authentication. Choosing Direct Shipping with one of these sellers comes with some great
        benefits:
      </p>
      <ul class="popinDeliveryService__list">
        <li
          class="popinDeliveryService__list__item"
          i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.TOPTIER.ITEM_1"
        >
          <b>Control & Authentication:</b> While Vestiaire Collective will not authenticate this item, this seller
          performs their own checks.
        </li>
        <li
          class="popinDeliveryService__list__item"
          i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.TOPTIER.ITEM_2"
        >
          <b>Quick & affordable:</b> Save {{ dsPromo }} on average and reduce delivery time by up to 40% by opting out
          of Vestiaire’s physical control and authentication process.
        </li>
        <li
          class="popinDeliveryService__list__item"
          i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LIST.TOPTIER.ITEM_3"
        >
          <b>Eco-friendly:</b> Lower shipping emissions as your parcel takes the most direct route to reach you.
        </li>
      </ul>
      <p class="popinDeliveryService__paragraph" i18n="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LAST_PARAGRAPH">
        Look out for
        <img
          class="popinDeliveryService__paragraph__icon"
          src="/assets/images/icons/handshake.svg"
          width="24"
          height="24"
          alt="Direct Shipping Icon"
        />
        Direct Shipping’ in our listings to see if your coveted item is eligible! For more information about Direct
        Shipping as a buyer or a seller, visit our
        <a
          i18n-href="@@POPIN_DELIVERY_SERVICE.DIRECT_SHIPPING.LAST_PARAGRAPH.LINK_URL"
          href="https://faq.vestiairecollective.com/hc/en-gb/categories/201084365-Buyer"
          target="_blank"
          rel="noopener noreferrer"
          >FAQ</a
        >.
      </p>
    </article>

    <article class="popinDeliveryService vc-body2 vcModal__container" *ngSwitchCase="'expressDelivery'">
      <h3
        class="popinDeliveryService__title vc-modal__title vc-title-s"
        i18n="@@POPIN_DELIVERY_SERVICE.EXPRESS_DELIVERY.TITLE"
      >
        Express Delivery
      </h3>
      <p class="popinDeliveryService__heading" i18n="@@POPIN_DELIVERY_SERVICE.EXPRESS_DELIVERY.HEADING">
        Express Delivery items are currently stored in our 3 warehouses (Paris, New York, Hong Kong) across the globe.
        Ordering from this selection has 3 benefits:
      </p>
      <ul class="popinDeliveryService__list">
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.EXPRESS_DELIVERY.LIST.ITEM_1">
          <b>It’s fast:</b> if you order an item from your region, it will leave our warehouse upon confirmation and
          arrive at your doorstep in as little as 48 hours. Also, our team will ensure that sellers respond to your
          questions even faster than usual.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.EXPRESS_DELIVERY.LIST.ITEM_2">
          <b>It’s reliable:</b> each item is photographed, described, controlled and authenticated by our expert teams
          to ensure you receive a genuine item that matches its description.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.EXPRESS_DELIVERY.LIST.ITEM_3">
          <b>It’s affordable:</b> Enjoy free control and authentication fees on this curated selection.
        </li>
      </ul>
      <p class="popinDeliveryService__paragraph" i18n="@@POPIN_DELIVERY_SERVICE.EXPRESS_DELIVERY.LAST_PARAGRAPH">
        Look out for
        <img
          class="popinDeliveryService__paragraph__icon"
          src="/assets/images/icons/express.svg"
          width="24"
          height="24"
          alt="Express Delivery Icon"
        />
        Express Delivery in our listings to see if your coveted item is eligible!
      </p>
    </article>

    <article class="popinDeliveryService vc-body2 vcModal__container" *ngSwitchCase="'bestOfAsia'">
      <h3
        class="popinDeliveryService__title vc-modal__title vc-title-s"
        i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_ASIA.TITLE"
      >
        Asia’s Best
      </h3>
      <p class="popinDeliveryService__heading" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_ASIA.HEADING">
        Asia’s Best is a curated selection of pieces from sellers wardrobes in the Asia-Pacific region. It has 3
        benefits:
      </p>
      <ul class="popinDeliveryService__list">
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_ASIA.LIST.ITEM_1">
          <b>It’s affordable:</b> Save 25% on average on your shipping fees compared to purchases from other continents.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_ASIA.LIST.ITEM_2">
          <b>It’s fast:</b> Reduce your delivery time as your items avoid longer-haul processing.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_ASIA.LIST.ITEM_3">
          <b>It’s more sustainable:</b> Lower your shipping emissions as your pieces travel shorter distances compared
          to purchases from other continents.
        </li>
      </ul>
    </article>

    <article class="popinDeliveryService vc-body2 vcModal__container" *ngSwitchCase="'bestOfUs'">
      <h3
        class="popinDeliveryService__title vc-modal__title vc-title-s"
        i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_US.TITLE"
      >
        Best of US
      </h3>
      <p class="popinDeliveryService__heading" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_US.HEADING">
        Best of US is a curated selection of pieces from US seller wardrobes. It has 3 benefits:
      </p>
      <ul class="popinDeliveryService__list">
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_US.LIST.ITEM_1">
          <b>It’s affordable:</b> On average save 25% on your shipping fees compared to purchases from other countries.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_US.LIST.ITEM_2">
          <b>It’s fast:</b> Reduce your delivery time as your items avoid overseas processing.
        </li>
        <li class="popinDeliveryService__list__item" i18n="@@POPIN_DELIVERY_SERVICE.BEST_OF_US.LIST.ITEM_3">
          <b>It’s more sustainable:</b> Lower your shipping emissions as your purchase travels domestically right to
          your doorstep.
        </li>
      </ul>
    </article>
  </ng-container>
</div>
